import __vue_normalize__ from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './ButtonControl.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({ref:"root",staticClass:"b24-btn",class:_vm.rootClass,attrs:{"type":_vm.nativeType,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[(_vm.loading)?_c('span',{staticClass:"b24-btn__loading"},[_c('loader',{staticClass:"b24-btn__loader",attrs:{"is-white":_vm.isWhiteLoader}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"b24-btn__content"},[_vm._t("default",[_vm._v("Отправить")])],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
